import React, { useEffect } from "react";
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useLocation,
  useRouteMatch,
} from "react-router-dom";
import PropTypes from "prop-types";

import { useSearchParams } from "routes/hooks";

import { Breadcrumb } from "components/Breadcrumb";

import { useInitActiveStep } from "./hooks";
import { OnboardingLayout, OnboardingStepsProvider, Step } from "./components";

export function Onboarding({ advisor }) {
  const history = useHistory();
  const { path } = useRouteMatch();
  const { pathname, search } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const { active, steps, loadingConfig } = useInitActiveStep(advisor);

  useEffect(() => {
    if (loadingConfig) return;
    if (!active.id) history.push("/");
    else if (!pathname.includes(active.id)) {
      history.push(`${active.id}${search || ""}`);
    }
  }, [pathname, search, active, history, loadingConfig]);

  useEffect(() => {
    if (!["crm", "add-user"].includes(active.id) && !searchParams?.plan) {
      setSearchParams({ ...searchParams, plan: "business" });
    }
  }, [active, searchParams, setSearchParams]);

  return (
    <OnboardingStepsProvider>
      <Switch>
        <Route exact path={`${path}/:activeStepId`}>
          <OnboardingLayout
            steps={<Breadcrumb steps={steps} activeStepIndex={active.idx} />}
          >
            <Step.Profile id="profile" user={advisor} />
            <Step.Subscription id="subscription" />
            <Step.CRMIntegration id="crm" />
            <Step.AddUserStep id="add-user" />
          </OnboardingLayout>
        </Route>

        <Redirect to={`${path}/${active.id}${search || ""}`} />
      </Switch>
    </OnboardingStepsProvider>
  );
}

Onboarding.propTypes = { advisor: PropTypes.object.isRequired };
Onboarding.defaultProps = {};

export default Onboarding;
